import * as SignUpActionTypes from '../actionTypes/signUpActionTypes';

export const setEmail = email => {
  return { type: SignUpActionTypes.SET_EMAIL, payload: email };
};
